import { CheckDottedIcon } from '@/components/Icons';
import { useRefreshData } from '@/hooks/useRefreshData';
import { updateDetail } from '@/service/audioList';
import { useNameChangeInputShow } from '@/state/namechange-store';
import dayjs from 'dayjs';
import React, { useRef } from 'react';

interface TrackNameProps {
  name: string;
  id: string;
  createAt: string;
}

export const TrackName = ({ name, id, createAt }: TrackNameProps) => {
  const { isNameInputShow, setIsNameInputShow } = useNameChangeInputShow();
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

  const { refreshAudioInList, refreshSongDetail } = useRefreshData();
  const updateName = async () => {
    const name = textAreaRef?.current?.value?.trim();
    if (!name) {
      return;
    }
    await updateDetail({
      id,
      name,
    });
    refreshSongDetail();
    refreshAudioInList({ id });

    setIsNameInputShow(false);
  };
  return (
    <div className="w-full mt-[10px] ">
      <div className="px-[8px] ml-jen-spacing-8  text-jen-size-heading-07 text-jen-content-tertiary flex justify-between items-center">
        <span>CREATED ON {dayjs(createAt).format('MMM D YYYY').toUpperCase()}</span>
        <span className="flex items-center">
          <CheckDottedIcon />
          <span className=" text-jen-content-primary">
            JENUINE<sup className="inline-block scale-75 z-[-1]">TM</sup>
          </span>
        </span>
      </div>

      {isNameInputShow ? (
        <textarea
          maxLength={500}
          autoFocus
          ref={textAreaRef}
          enterKeyHint="done"
          rows={3}
          className=" focus:border-[#ff5b2799] ml-jen-spacing-8 outline-none  p-jen-spacing-8 leading-[32px] w-[340px] border border-jen-border rounded-lg  text-[32px]"
          defaultValue={name}
          onKeyDown={async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              updateName();
            }
            if (e.key === 'Escape') {
              // onClose();
              setIsNameInputShow(false);
            }
          }}
          onBlur={() => {
            updateName();
          }}
        />
      ) : (
        <div
          title={name}
          className="track_name_box ml-jen-spacing-8 p-jen-spacing-8 pb-0 leading-[32px]  line-clamp-3 break-all text-[32px]"
          onClick={() => setIsNameInputShow(true)}
        >
          {name}
        </div>
      )}
    </div>
  );
};
